




































































import { Component, Vue, Watch } from "vue-property-decorator";
import Axios from "../../plugins/http";

@Component
export default class Index extends Vue {
  phone: string = "";
  info: any = {};
  money: number = null;
  dialogVisible: boolean = false;
  display: boolean = false;

  created() {
    this.getDetailInfo();
  }
  getDetailInfo() {
    Axios.getSecret(`/api/user/my_info`).then(res => {
      if (res.data.status === 200) {
        this.info = res.data.data;
      } else {
        this.$message(res.data.msg);
      }
    });
  }
  changeKey() {
    this.$confirm(
      "当前的SK将会立即失效\n更新完成之后请立即重新配置应用的SK\n定期更改SK有助于保护您的数据安全\n是否立即更新?",
      "更改SK",
      {
        confirmButtonText: "更改",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "accountConfirm"
      }
    ).then(() => {
      Axios.postByQs("/api/user/sk/update", {})
        .then(res => {
          if (res.data.status === 200) {
            this.$message({
              type: "success",
              message: `更改成功`
            });
            this.getDetailInfo();
          } else {
            this.$message(res.data.msg);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    });
  }

  copySecretkey() {
    let input: any = document.getElementById("copy");
    let text = this.info.secretKey;
    input.value = text; // 修改文本框的内容
    input.select(); // 选中文本
    document.execCommand("copy"); // 执行浏览器复制命令
  }
}
